// import { Controller, useFormContext } from 'react-hook-form';
// import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/material.css';
// import { Box, FormHelperText } from '@mui/material';

// const RHFPhoneField = ({ name, label, ...other }) => {

//     const { control } = useFormContext();

//     return (
//         <Controller
//             name={name}
//             control={control}
//             render={({ field, fieldState }) => (
//                 <Box>
//                     <PhoneInput
//                         country={'us'}
//                         value={field.value || ''}
//                         onChange={phone => field.onChange(phone)}

//                         inputProps={{
//                             name,
//                             ...other,
//                         }}
//                         inputStyle={{
//                             width: '100%',
//                             height: '50px',
//                             fontSize: '16px',
//                             paddingLeft: "50px",
//                             borderRadius: '7px',
//                             border: fieldState.error
//                                 ? '1px solid #d32f2f'
//                                 : field.value
//                                     ? '2px solid #000'
//                                     : '1px solid #c4c4c4db',
//                             outline: 'none',
//                             transition: 'border-color 0.2s',

//                         }}
//                         specialLabel={label}
//                         isValid={!fieldState.error}
//                         containerStyle={{ width: '100%' }}
//                     />
//                     {fieldState.error && (
//                         <FormHelperText error={fieldState.error}>
//                             {fieldState.error.message}
//                         </FormHelperText>
//                     )}
//                 </Box>
//             )}
//         />
//     );
// };

// export default RHFPhoneField;

import { Controller, useFormContext } from 'react-hook-form';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import { Box, FormHelperText } from '@mui/material';
import { PHONE_COUNTRIES, PHONE_DIAL_CODE, PHONE_NATIONAL_LENGTH } from 'src/utils/phone';

const PHONE_NATIONAL_MASK = '(...) ...-....';
const PHONE_MASKS = Object.fromEntries(
    PHONE_COUNTRIES.map((country) => [country, PHONE_NATIONAL_MASK])
);

const PHONE_MAX_DIGITS = PHONE_DIAL_CODE.length + PHONE_NATIONAL_LENGTH;

const RHFPhoneField = ({ name, label, placeholder = '', ...other }) => {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState }) => (
                <Box>
                    <PhoneInput
                        country={PHONE_COUNTRIES[0]}
                        onlyCountries={PHONE_COUNTRIES}
                        masks={PHONE_MASKS}
                        placeholder={placeholder}
                        countryCodeEditable={false}
                        value={field.value || ''}
                        onChange={(phone) => {
                            const digits = String(phone || '').replace(/\D/g, '').slice(0, PHONE_MAX_DIGITS);
                            field.onChange(digits ? `+${digits}` : '');
                          }}
                        disabled={other?.inputProps?.readOnly}
                        inputProps={{
                            name,
                            type: 'tel',
                            autoComplete: 'tel',
                            inputMode: 'tel',
                            readOnly: other?.inputProps?.readOnly || false,
                        }}
                        inputStyle={{
                            width: '100%',
                            height: '53px',
                            fontSize: '16px',
                            paddingLeft: "50px",
                            borderRadius: '7px',
                            border: fieldState.error
                                ? '1px solid #d32f2f'
                                : field.value
                                    ? '2px solid #000'
                                    : '1px solid #c4c4c4db',
                            outline: 'none',
                            transition: 'border-color 0.2s',

                        }}
                        specialLabel={label}
                        isValid={!fieldState.error
                        }
                        containerStyle={{ width: '100%' }}
                    />

                    {fieldState.error && (
                        <FormHelperText error sx={{ mx: 1.75 }}>
                            {fieldState.error.message}
                        </FormHelperText>
                    )}
                </Box>
            )}
        />
    );
};

export default RHFPhoneField;

